module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.currentlyVisible,
      "before-close": _vm.handleClose,
      "title": "Export current selection",
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.currentlyVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "action-text"
  }, [(_vm.filterBy === 'survey') ? _c('div', [_vm._v("\n      Exporting all respondents to\n      "), _c('strong', [_vm._v("CSV")]), _vm._v(" for survey\n      "), _c('strong', [_vm._v(_vm._s(_vm.surveyName))]), _vm._v(".\n      "), (_vm.questionTitle !== '') ? _c('span', [_vm._v("\n        For the question:\n        "), _c('em', {
    staticClass: "question-title"
  }, [_vm._v(_vm._s(_vm.questionTitle))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'period') ? _c('div', [_vm._v("\n      Exporting respondents to\n      "), _c('strong', [_vm._v("CSV")]), _vm._v(" for the period\n      "), _c('strong', [_vm._v(_vm._s(_vm.periodType) + ".")]), _vm._v(" "), (_vm.periodType !== 'lifetime') ? _c('span', [_vm._v("\n        Starting from\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.datetime, 'Do MMM YYYY')) + ".")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportRespondents
    }
  }, [_vm._v("Export")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6891d69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SurveyExportFormDialog.vue
// module id = 3320
// module chunks = 3